import React, { useState } from 'react';
import { useConfig } from '../context/ConfigContext';

const Header = ({ pageKey, title, subtitle, subtitleType = 'text', subtitleImage }) => {
    // Función para limpiar siempre la caché de imágenes
    const [cacheBuster] = useState(() => Date.now());
    const getCleanImageUrl = (url) => {
        if (!url) return '';
        return `${url}${url.includes('?') ? '&' : '?'}v=${cacheBuster}`;
    };

    const { config } = useConfig();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    React.useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isAgendaGroup = ['agenda', 'questions_private', 'interactiva', 'register'].includes(pageKey);
    // Cardio Summit 2026 — Logo oficial centrado
    const isCustomUploaded = config?.logoUrl && !config.logoUrl.includes('logo.png') && !config.logoUrl.includes('LOGO_123.png');
    const logoUrl = isCustomUploaded
        ? getCleanImageUrl(config.logoUrl)
        : '/assets/cardio/CS_Logo.png';

    const pageDesign = config?.pageDesigns?.[pageKey] || {};
    const fontColor = pageDesign.globalFontColor || config?.globalFontColor || config?.primaryColor || '#c0392b';

    return (
        <header className="relative w-full z-50 flex-shrink-0 flex flex-col items-center pointer-events-none">
            <div className="relative w-full flex flex-col items-center">
                {/* Logo Cardio Summit — centrado y acotado */}
                {logoUrl && (
                    <div className="w-full flex justify-center pt-6 pb-2">
                        <img
                            src={logoUrl}
                            alt="Cardio Summit"
                            className="w-[200px] sm:w-[240px] h-auto object-contain drop-shadow-lg"
                            loading="eager"
                        />
                    </div>
                )}

                {/* Optional Page Title & Subtitle */}
                {pageKey !== 'agenda' && (title || subtitle || (subtitleType === 'image' && subtitleImage)) && (
                    <div className="mt-6 text-center animate-fadeInUp">
                        {title && (
                            <h2
                                className="font-black uppercase tracking-wider drop-shadow-lg text-2xl sm:text-4xl"
                                style={{
                                    background: 'linear-gradient(to right, #033f83, #079acf, #65bade)',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    backgroundClip: 'text',
                                    color: 'transparent'
                                }}
                            >
                                {title}
                            </h2>
                        )}
                        {subtitleType === 'image' && subtitleImage ? (
                            <div className="mt-3 max-w-[250px] mx-auto">
                                <img
                                    src={subtitleImage}
                                    alt="Subtitle"
                                    className="w-full h-auto object-contain max-h-[80px]"
                                />
                            </div>
                        ) : (
                            subtitle && (
                                <div className="inline-block mt-2 px-4 py-1 bg-white/10 backdrop-blur-md rounded-full border border-white/20">
                                    <p
                                        className="text-[10px] sm:text-xs font-bold uppercase tracking-widest"
                                        style={{
                                            background: 'linear-gradient(to right, #033f83, #079acf, #65bade)',
                                            WebkitBackgroundClip: 'text',
                                            WebkitTextFillColor: 'transparent',
                                            backgroundClip: 'text',
                                            color: 'transparent'
                                        }}
                                    >
                                        {subtitle}
                                    </p>
                                </div>
                            )
                        )}
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;
